import { useEffect, useState } from "react";

/**
 * @returns  scroll direction scrolling up or down
 */
export function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState<"up" | "down" | null>(
    null
  );
  let lastScrollTop = 0;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      setScrollDirection(() => {
        const direction = currentScrollTop > lastScrollTop ? "down" : "up";
        lastScrollTop = currentScrollTop;
        return direction;
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return scrollDirection;
}
